import React from "react";

export const About = (props) => {
  return (
    <>
      <style>{`
        #about {
          padding: 80px 0;
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        #about .container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #about .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
          box-sizing: border-box;
        }
        #about .col-xs-12 {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #about .col-md-6 {
          width: 100%;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #about img {
          width: 100%;
          max-width: 100%;
          height: auto;
          margin-top: 10px;
          background: #fff;
          box-shadow: 0 0 50px rgba(0,0,0,0.06);
          border-radius: 4px;
          display: block;
        }
        #about p {
          line-height: 24px;
          margin: 20px 0;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        #about h3 {
          font-size: 18px;
          margin: 0 0 12px;
        }
        #about .about-text {
          width: 100%;
          box-sizing: border-box;
        }
        .about-why-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0;
          width: 100%;
          box-sizing: border-box;
        }
        .about-why-col {
          width: 50%;
          box-sizing: border-box;
          padding-right: 10px;
        }
        .about-why-col:last-child {
          padding-right: 0;
        }
        #about .list-style ul {
          padding-left: 18px;
          margin: 0;
          box-sizing: border-box;
        }
        #about .list-style ul li {
          word-wrap: break-word;
          overflow-wrap: break-word;
        }

        /* Desktop: col-md-6 = 50% */
        @media (min-width: 992px) {
          #about .col-md-6 {
            width: 50%;
          }
        }

        /* Mobile */
        @media (max-width: 767px) {
          #about {
            padding: 48px 0;
          }
          #about img {
            margin-bottom: 28px;
          }
          #about h2 {
            font-size: 26px;
            margin-bottom: 10px;
          }
          #about h3 {
            font-size: 16px;
            margin-top: 20px;
          }
          #about p {
            font-size: 14px;
          }
          #about .about-text li {
            font-size: 13px;
          }
          .about-why-row {
            flex-direction: column;
          }
          .about-why-col {
            width: 100% !important;
            margin-bottom: 8px;
            padding-right: 0;
          }
        }
        @media (max-width: 640px) {
          #about .col-md-6 {
            width: 100%;
          }
        }
      `}</style>
      <div id="about">
        <div className="container">
          <div className="row">
            {/* Gambar */}
            <div className="col-xs-12 col-md-6">
              <img src="img/abo ut.jpg" className="img-responsive" alt="" />
            </div>
            {/* Teks */}
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>About Us</h2>
                <p>{props.data ? props.data.paragraph : "loading..."}</p>
                <div className="about-why-row">
                  {/* Kiri */}
                  <div className="about-why-col">
                    <h3>Visi dan Misi kami?</h3>
                    <div className="list-style">
                      <ul>
                        {props.data
                          ? props.data.Why.map((d, i) => (
                              <li key={`${d}-${i}`}>{d}</li>
                            ))
                          : "loading"}
                      </ul>
                    </div>
                  </div>
                  {/* Kanan */}
                  <div className="about-why-col">
                    <h3>Mengapa Memilih Corebuild Solution?</h3>
                    <div className="list-style">
                      <ul>
                        {props.data
                          ? props.data.Why2.map((d, i) => (
                              <li key={`${d}-${i}`}>{d}</li>
                            ))
                          : "loading"}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};